import { render, staticRenderFns } from "./OpeningBalanceCost.vue?vue&type=template&id=5191d2f9&scoped=true"
import script from "./OpeningBalanceCost.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceCost.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalanceCost.vue?vue&type=style&index=0&id=5191d2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191d2f9",
  null
  
)

export default component.exports